module.exports = __webpack_public_path__ + "img/servicio-especial.32df3648.png";